import { useAuth0 } from '@auth0/auth0-react';

const Membership = () => {
  const { user } = useAuth0();

  return (
    <div className="bg-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Welcome to Membership, {user?.name}!
          </h2>
          <p className="text-lg text-gray-600 mb-8">
            You now have access to exclusive member prices
          </p>
          {/* Add membership content here */}
        </div>
      </div>
    </div>
  );
};

export default Membership; 